// extracted by mini-css-extract-plugin
export var container = "_5q-1";
export var editor = "_5q-2";
export var resizable = "_5q-3";
export var wrapper = "_5q-0";